import httpClient, { handleSuccess, handleError, apiHeader } from './httpClient'

export function list(formData) {
  const params = new URLSearchParams()
  params.append('currentPage', formData.currentPage)
  params.append('perPage', formData.perPage)
  params.append('sortBy', formData.sortBy)
  params.append('sortDesc', formData.sortDesc)
  params.append('filter', formData.filter)
  params.append('admin_status', formData.admin_status)

  return httpClient.post('user/list', params, apiHeader).then(handleSuccess).catch(handleError)
}

export function create(formData) {
  const params = new URLSearchParams()
  params.append('tags', formData.tags)
  params.append('last_name', formData.last_name)
  params.append('first_name', formData.first_name)
  params.append('email', formData.email)
  params.append('password', formData.password)
  params.append('password_confirm', formData.password_confirm)
  params.append('admin_status', formData.admin_status)

  return httpClient.post('user/create', params, apiHeader).then(handleSuccess).catch(handleError)
}

export function update(formData) {
  const params = new URLSearchParams()
  params.append('id', formData.id)
  params.append('tags', formData.tags)
  params.append('last_name', formData.last_name)
  params.append('first_name', formData.first_name)
  params.append('email', formData.email)
  params.append('password', formData.password)
  params.append('password_confirm', formData.password_confirm)
  params.append('admin_status', formData.admin_status)

  return httpClient.post('user/update', params, apiHeader).then(handleSuccess).catch(handleError)
}

export function passwordUpdate(formData) {
  const params = new URLSearchParams()
  params.append('password', formData.password)
  params.append('change_password', formData.change_password)
  params.append('confirm_password', formData.confirm_password)

  return httpClient.post('user/password_update', params, apiHeader).then(handleSuccess).catch(handleError)
}

export function _delete(formData) {
  const params = new URLSearchParams()
  params.append('id', formData.id)

  return httpClient.post('user/delete', params, apiHeader).then(handleSuccess).catch(handleError)
}

export function downloadCSV(formData) {
  const params = new URLSearchParams()
  params.append('admin_status', formData.admin_status)

  return httpClient.post('user/csv', params, apiHeader).then(handleSuccess).catch(handleError)
}
